import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubHeaderService } from 'src/app/shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { View } from '../../../../shared/store/view/types';
import { ViewService } from '../../../../shared/store/view/views.service';
import { ClaimTypeService } from 'src/app/shared/store/claim-type/claim-type.service';
import { ClaimTypeModel } from 'src/app/shared/store/claim-type/types';

@UntilDestroy()
@Component({
  selector: 'app-claim-type-details',
  templateUrl: './claim-type-details.component.html',
  styleUrls: ['./claim-type-details.component.scss'],
  standalone: false,
})
export class ClaimTypeDetailsComponent implements OnInit, OnDestroy {
  claimTypeId: number;
  claimType$: Observable<ClaimTypeModel>;
  view$: Observable<View>;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly claimTypeService: ClaimTypeService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
  ) {
    this.claimType$ = this.claimTypeService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.claimTypeId = this.route.snapshot.params['id'];
    this.claimTypeService.getById.call(this.claimTypeId);

    this.claimType$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@claimTypeDetails', x.name);
      });
    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'claimTypeEdit') {
          this.router.navigate([
            'Insurance/ClaimTypes/Edit/',
            this.claimTypeId,
          ]);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.claimTypeService.getById.reset();
    this.breadcrumbService.set('@claimTypeDetails', ' ');
  }
}
